export default "__VITE_ASSET__df8245fe__"